(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-template"]) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
        constructor() {
            super();

            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);

                fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                        if ($('.product-grid-slider').length) {
                            $(".product-grid-slider").slick({
                                dots: false,
                                infinite: false,
                                autoplay: false,
                                slidesToShow: 6,
                                slidesToScroll: 6,
                                nextArrow: '<div class="slider-arrow next-arrow inset"><img src="https://cdn.shopify.com/s/files/1/0038/0377/5049/files/next-arrow.svg?v=1630351704" alt="Next arrow" /></div>',
                                prevArrow: '<div class="slider-arrow prev-arrow inset"><img src="https://cdn.shopify.com/s/files/1/0038/0377/5049/files/prev-arrow.svg?v=1630351718" alt="Previous arrow" /></div>',
                                responsive: [
                                  {
                                    breakpoint: 992,
                                    settings: {
                                      slidesToShow: 4,
                                      slidesToScroll: 4,
                                    }
                                  },
                                  {
                                    breakpoint: 768,
                                    settings: {
                                      slidesToShow: 3,
                                      slidesToScroll: 3,
                                    }
                                  },
                                  {
                                    breakpoint: 576,
                                    settings: {
                                      slidesToShow: 2,
                                      slidesToScroll: 2,
                                    }
                                  }
                                ]
                            });
                        }
                    }
                })
                .catch(e => {
                    console.error(e);
                });
            }
            new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
        }
    }

    customElements.define('product-recommendations', ProductRecommendations);

    class ProductRecommendationsShort extends HTMLElement {
        constructor() {
            super();

            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);

                fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations-short');
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }
                })
                .catch(e => {
                    console.error(e);
                });
            }
            new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
        }
    }

    customElements.define('product-recommendations-short', ProductRecommendationsShort);

  } catch(e) { console.error(e); }
})();

})();
